import { Avatar } from "@/components/ui/avatar"

interface NotionAvatarProps {
  className?: string
  name: string
  profileImage?: string
  alt?: string
}

/**
 * NotionAvatar component for displaying Notion user avatars
 * Shows Notion profile image if available, otherwise shows initials
 * This is separate from UserAvatar which is for WordPress users
 */
export function NotionAvatar({ 
  className = "h-8 w-8", 
  name,
  profileImage,
  alt 
}: NotionAvatarProps) {
  const finalAlt = alt || name

  const getInitials = (displayName: string) => {
    return displayName
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .slice(0, 2)
  }

  return (
    <Avatar className={`flex-shrink-0 ${className}`}>
      {profileImage ? (
        <img 
          src={profileImage} 
          alt={finalAlt}
          className="h-full w-full object-cover rounded-full" 
          onError={(e) => {
            // Hide image on error and show initials fallback
            e.currentTarget.style.display = 'none'
          }}
        />
      ) : null}
      {/* Initials fallback - always rendered but hidden if image loads */}
      <div className={`h-full w-full bg-primary/10 flex items-center justify-center rounded-full ${profileImage ? 'absolute inset-0 -z-10' : ''}`}>
        <span className="text-xs font-medium text-primary">
          {getInitials(name)}
        </span>
      </div>
    </Avatar>
  )
}
